module.exports = __webpack_public_path__ + "img/alur-pendaftaran-merek.c47f81ef.png";